/**
 * DeleteConfirmDialog - Confirmation dialog for preset deletion
 */
import React, { memo } from 'react';
import { Button } from './ui/button';
import { Trash2 } from 'lucide-react';

const DeleteConfirmDialog = memo(({
  isVisible,
  preset,
  loading,
  onClose,
  onDelete,
}) => {
  if (!isVisible || !preset) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="delete-confirm-dialog">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-6 rounded-xl max-w-md w-full mx-4 border border-red-500/20">
        <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
          <Trash2 className="w-5 h-5 text-red-400" />
          Delete Preset
        </h3>

        <div className="space-y-4">
          <div className="bg-red-500/20 border border-red-500/30 p-4 rounded-lg">
            <div className="text-red-300 text-sm font-medium mb-2">
              Are you sure you want to delete this preset?
            </div>
            <div className="text-white font-medium">
              &ldquo;{preset.name}&rdquo;
            </div>
            <div className="text-white/70 text-sm mt-2">
              {preset.description || 'No description'}
            </div>
          </div>

          <div className="bg-yellow-500/20 border border-yellow-500/30 p-3 rounded-lg">
            <div className="text-yellow-300 text-sm flex items-center gap-2">
              <span>Warning</span>
            </div>
            <div className="text-white/70 text-xs mt-1">
              This action cannot be undone. The preset will be permanently removed from your library.
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              className="flex-1 bg-gray-600 hover:bg-gray-700"
              data-testid="delete-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              onClick={() => onDelete(preset.id, preset.name)}
              disabled={loading}
              className="flex-1 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
              data-testid="delete-confirm-btn"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              {loading ? 'Deleting...' : 'Delete Preset'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

DeleteConfirmDialog.displayName = 'DeleteConfirmDialog';

export default DeleteConfirmDialog;
